import { render, staticRenderFns } from "./EditBranch.vue?vue&type=template&id=6bd50cde&scoped=true&"
import script from "./EditBranch.vue?vue&type=script&lang=ts&"
export * from "./EditBranch.vue?vue&type=script&lang=ts&"
import style0 from "./EditBranch.vue?vue&type=style&index=0&id=6bd50cde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd50cde",
  null
  
)

export default component.exports